import {
    NotificationIconProps,
} from '../NotificationIcon/notificationIcon.types'
import Validated from '../Validated'
import {
    ActionLinkFunction,
    ValidationResult,
} from '../../types/form.types'
import NotificationIcon from '../NotificationIcon'
import ActionLink from '../ActionLink'

type Props = {
    validated?: boolean,
    notificationIconProps?: NotificationIconProps,
    children: JSX.Element,
    errors?: ValidationResult,
    actionLinkFunction?: ActionLinkFunction
    classNames?: {
        labelContainer?: string,
    }
}

const defaultProps: Partial<Props> = {
    validated: false,
    notificationIconProps: undefined,
    errors: undefined,
    actionLinkFunction: undefined,
    classNames: {},
}

export default function LabelPanel({
    validated,
    notificationIconProps,
    children,
    errors,
    actionLinkFunction,
    classNames,
}: Readonly<Props>) {
    if (!validated && !actionLinkFunction && !notificationIconProps) return children
    return (
        <ActionLink
            actionLinkFunction={actionLinkFunction}
            className={classNames.labelContainer}
        >
            <Validated
                validated={validated}
                errors={errors}
            >
                <NotificationIcon
                    type={notificationIconProps?.type}
                    content={notificationIconProps?.content}
                    tooltipPlacement={notificationIconProps?.tooltipPlacement}
                >
                    {children}
                </NotificationIcon>
            </Validated>
        </ActionLink>
    )
}

LabelPanel.defaultProps = defaultProps
